export enum UserRoleType {
  CS = 'viewer:clients-sensitive-data',
  OMNI_HR = 'viewer:omnipresent-sensitive-data',
  PAYROLL = 'payroll',
  FINANCE = 'finance',
  INTERNATIONAL_EXPANSION = 'international-expansion',
  BENEFITS_SPECIALIST = 'benefits-specialist',
  ADMIN = 'admin',
  MANAGER = 'manager',
  EMPLOYEE = 'employee',
  LSP = 'lsp',
  CONTRACTOR = 'contractor',
}

export type UserRole = {
  id?: string;
  tenantId?: string;
  type: UserRoleType;
  scopes?: string[];
};

export type User = {
  userId: string;
  authId: string;
  firstName: string;
  lastName: string;
  displayName: string;
  name: string;
  email: string;
  temporaryPassword?: string;
  roles: UserRole[];
  seenWelcomeScreen: boolean;
  seenPrivacyPolicy?: string;
  sentInvitationAt?: string;
  createdAt?: string;
  role?: UserRole;
  updatedBy?: string;
  updatedAt?: string;
};
